/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import RichTextInputProps from "./RichTextInputProps";

const RichTextInputCore = React.lazy(() => import(/* webpackPreload: true */ "./Core"));
export default function RichTextInput(props: RichTextInputProps) {
    return (
        <RichTextInputCore {...props} />
    );
}